module.exports = __webpack_public_path__ + "img/profilepic.00c732cf.jpg";